/**
 * Recursively searches through contentful rows to find the first rich text with a color
 * @param {Array} rows - Array of contentful rows to search through
 * @returns {string|null} - Returns the color ('White' or 'Black') or null if not found
 */
const findFirstRichTextColor = (rows = []) => {
  const checkItems = (items) => {
    if (!items) return null;
    for (const item of items) {
      if (
        item?.__typename === 'ContentfulRichText' &&
        (item?.color === 'White' || item?.color === 'Black')
      ) {
        return item.color;
      }
      // Check nested rows
      if (item?.rows) {
        for (const row of item.rows) {
          if (row?.columns) {
            for (const column of row.columns) {
              if (column?.items) {
                const color = checkItems(column.items);
                if (color) return color;
              }
            }
          }
        }
      }
    }
    return null;
  };

  for (const row of rows) {
    if (row?.columns) {
      for (const column of row.columns) {
        if (column?.items) {
          const color = checkItems(column.items);
          if (color) return color;
        }
      }
    }
  }

  return null;
};

export default findFirstRichTextColor;
